import { useAuth } from "@/context/AuthContext";
import { PageHeader, Card } from "@/components/bits";
import StatusBadge from "@/components/StatusBadge";
import { Info } from "lucide-react";

export default function SettingsPage() {
  const { user } = useAuth();
  return (
    <div>
      <PageHeader title="Settings" subtitle="Informasi sistem & profil akun." />
      <div className="grid lg:grid-cols-2 gap-4">
        <Card className="p-5">
          <h3 className="font-head font-semibold text-gray-900 mb-3">Profil Akun</h3>
          <dl className="space-y-2 text-sm">
            <div className="flex justify-between"><dt className="text-gray-400">Nama</dt><dd className="font-medium">{user.name}</dd></div>
            <div className="flex justify-between"><dt className="text-gray-400">Email</dt><dd className="font-medium">{user.email}</dd></div>
            <div className="flex justify-between items-center"><dt className="text-gray-400">Role</dt><dd className="font-medium">{user.role_label}</dd></div>
          </dl>
        </Card>
        <Card className="p-5">
          <h3 className="font-head font-semibold text-gray-900 mb-3">Sistem</h3>
          <dl className="space-y-2 text-sm">
            <div className="flex justify-between"><dt className="text-gray-400">Aplikasi</dt><dd className="font-medium">TITANIUM PARTS</dd></div>
            <div className="flex justify-between"><dt className="text-gray-400">Tagline</dt><dd className="font-medium text-[var(--gold)]">Right Part. Right Car. Right Control.</dd></div>
            <div className="flex justify-between"><dt className="text-gray-400">AI OCR Engine</dt><dd className="font-medium">Gemini 3.1 Pro</dd></div>
            <div className="flex justify-between"><dt className="text-gray-400">Versi</dt><dd className="font-medium">V1</dd></div>
          </dl>
        </Card>
      </div>
      <Card className="p-4 mt-4 bg-gray-50 flex items-start gap-3">
        <Info size={18} className="text-gray-400 mt-0.5 shrink-0" />
        <p className="text-sm text-gray-600">Alur sistem: <b>SPK → Required Parts → Part Masuk → Matching → Complete/Partial → Part Keluar → Terpasang</b>. Semua transaksi menggunakan ledger immutable dengan audit log.</p>
      </Card>
    </div>
  );
}
